import HeroSection from './components/HeroSection';
import ImpactSection from './components/ImpactSection';
import PlasticWoodSection from './components/PlasticWoodSection';
import ServicesSection from './components/ServicesSection';
import RecyclingImportanceSection from './components/RecyclingImportanceSection';
import ElectronicsSection from './components/ElectronicsSection';
import GallerySection from './components/GallerySection';
import CtaDonation from './components/CtaDonation';

export default function HomePage() {
  return (
    <main>
      <HeroSection />
      <ImpactSection />
      <PlasticWoodSection />
      <ServicesSection />
      <RecyclingImportanceSection />
      <ElectronicsSection />
      <GallerySection />
      <CtaDonation />
    </main>
  );
}
